import { render, staticRenderFns } from "./IconBtn.vue?vue&type=template&id=8d5b63ba&scoped=true&"
import script from "./IconBtn.vue?vue&type=script&lang=ts&"
export * from "./IconBtn.vue?vue&type=script&lang=ts&"
import style0 from "./IconBtn.vue?vue&type=style&index=0&id=8d5b63ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d5b63ba",
  null
  
)

export default component.exports